/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Reject_LabelInputs */

const vi_sl_detail_dialog_reject_label = /** @type {(inputs: Sl_Detail_Dialog_Reject_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do từ chối`)
};

/**

* @param {Sl_Detail_Dialog_Reject_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_reject_label = /** @type {((inputs?: Sl_Detail_Dialog_Reject_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Reject_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_reject_label(inputs)
});